import { createReducer } from '@reduxjs/toolkit'

const initialState = {
  items: [],
  currentItem: {},
  pagination: {
    total: 1,
    page: 1,
    pageCount: 1
  },
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: ''
}

const pickupAuthorizationChild = createReducer(initialState, {
  'authorizations/GET_P_A_CHILD': (state, action) => ({
    ...state,
    isFetching: true
  }),
  'authorizations/GET_P_A_CHILD_SUCCESSFUL': (state, action) => {
    return {
      ...state,
      items: action.payload.response.data,
      isFetching: false,
      pagination: {
        total: action.payload.response.meta.total_count,
        pageCount: action.payload.response.meta.page_count,
        page: action.payload.current_page
      }
    }
  },
  'authorizations/GET_P_A_CHILD_FAILURE': (state, action) => {
    return {
      ...state,
      isFetching: false,
      isError: true,
      errorMessage: action.payload
    }
  }
})

export default pickupAuthorizationChild
